export default "__VITE_ASSET__3EKH6Uzu__"